export const LIMIT_TYPES = ['dailyLimit', 'weeklyLimit', 'monthlyLimit']
export const MAX_EVENT_LIMIT = 9999
